import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import Icon from '../../../components/Icon';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const WrapperLeft = styled.div<{
  error: boolean;
}>`
  width: calc(100% - 48px);
  border-radius: 4px;
  border: 1px solid ${(props) => (props.error ? '#e8212b' : '#ecf4f9')};
  background-color: #ecf4f9;
`;

const WrapperRight = styled.div``;

const WrapperTop = styled.div`
  height: 48px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > div {
    > p {
      font-weight: 700;
      font-size: 14px;
      color: #161d1f;
    }

    > span {
      font-size: 12px;
      color: #4f6168;
    }
  }
`;

const WrapperBottom = styled.div<{
  error: boolean;
}>`
  padding: 8px;
  display: ${(props) => (props.error ? 'flex' : 'none')};
  align-items: center;
  gap: 8px;
  border-top: 1px solid #cfd4e5;

  > p {
    font-size: 12px;
    color: #e8212b;
  }
`;

const WrapperButton = styled.button`
  // height: 40px;
  // width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface IProps {
  accept: string[];
  download: (file: any) => void;
  file: any;
  maxFiles: number;
  maxSizeMegabytes: number;
  nameValue: string;
  remove: (file: any) => void;
  sizeValue: string;
  noDown?: boolean;
}

const ComponentFile = ({
  accept,
  download,
  file,
  maxFiles,
  maxSizeMegabytes,
  nameValue,
  remove,
  sizeValue,
  noDown
}: IProps) => {
  const [error, setError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    const maxSizeFile = maxSizeMegabytes / maxFiles;

    if (file) {
      if (Math.round(file.size * 100) > Math.round(maxSizeFile * 100)) {
        setError(true);
        setErrorMessage(
          `Este archivo es muy pesado. (carga máxima ${maxSizeFile}MB)`
        );
      } else if (file.originalName?.length >= 200) {
        setError(true);
        setErrorMessage('¡Ups! el nombre de tu archivo es demasiado extenso.');
      } else if (!accept.some((ext) => file.ext === ext)) {
        setError(true);
        setErrorMessage('¡Oh no! Este archivo no es compatible.');
      } else {
        setError(false);
        setErrorMessage('');
      }
    }
  }, [accept]);

  return (
    <>
      {file && (
        <Wrapper>
          <WrapperLeft error={error}>
            <WrapperTop>
              <div
                style={{
                  width: '100%'
                }}
              >
                <p
                  style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    wordWrap: 'break-word',
                    textOverflow: 'ellipsis'
                  }}
                >
                  {file[nameValue]}
                </p>
                <span>{file[sizeValue]} MB</span>
              </div>
              {!noDown && (
                <WrapperButton
                  type="button"
                  onClick={() => remove(file)}
                  data-testid="cmp-upload-button-remove"
                >
                  <Icon name="trash-2" size={19} color="#1A055D" />
                </WrapperButton>
              )}
            </WrapperTop>
            <WrapperBottom error={error}>
              <Icon name="alert-triangle" size={14} color="#e8212b" />
              <p>{errorMessage}</p>
            </WrapperBottom>
          </WrapperLeft>
          <WrapperRight>
            {noDown ? (
              <WrapperButton
                type="button"
                onClick={() => remove(file)}
                data-testid="cmp-upload-button-remove"
              >
                <Icon name="trash-2" size={19} color="#1A055D" />
              </WrapperButton>
            ) : (
              <WrapperButton
                type="button"
                onClick={() => download(file)}
                data-testid="cmp-upload-button-download"
              >
                <Icon name="download" size={19} color="#1A055D" />
              </WrapperButton>
            )}
          </WrapperRight>
        </Wrapper>
      )}
    </>
  );
};

export default ComponentFile;
